<template>
	<div class="offer-summary-item" v-if="validOffer">
		<div class="offer-info">
			<div class="offer-name">
				{{ offer.name }}
			</div>
			<div class="offer-description">
				{{ offer.description }}
			</div>
		</div>
		<a class="remove-offer" @click="removeOffer">Remove</a>
		<small>(apply offer later)</small>
	</div>
</template>

<script>
	import EventBus from '@EventBus';
	import offersMixin from '@Mixin/offersMixin';
	import Formatter from "@/utils/Formatter";
	import accountMixin from '@Mixin/accountMixin';

	export default {
		mixins: [
			offersMixin,
			accountMixin,
		],
		computed: {
			validOffer() {
				if (this.hasOffersInCart()) {
					return true;
				}
				return false;
			}
		},
		props: {
			offer: {
				type: Object,
				default: {
					name: 'Unknown',
					description: '',
				}
			},
		},
		methods: {
			removeOffer() {
				const offer = this.offer;
				this.removeOfferFromItem(offer);
				EventBus.$emit('item-added-coupon');
				EventBus.$emit('recalculate-order');
			},
		},
		watch: {
			customer(newCustomer, oldCustomer) {
				if (newCustomer && newCustomer.id === null) {
					this.removeOffer();
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import 'globalStyles';
	.offer-summary-item {
		margin: 1rem 0;
		.offer-info {
			margin-bottom: 0.5rem;
			.offer-name {
				font-weight: bold;
			}
			.offer-amount {
				color: $discountColor;

				font-weight: bold;
			}
		}
		.remove-offer {
			color: $storeButtonColor;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/checkout/OfferSummaryItem.vue